/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Notifications_Apikey_Clear1Inputs */

const id_notifications_apikey_clear1 = /** @type {(inputs: Notifications_Apikey_Clear1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Hapus Kunci`)
};

const ms_notifications_apikey_clear1 = /** @type {(inputs: Notifications_Apikey_Clear1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Kosongkan Kunci`)
};

const da_notifications_apikey_clear1 = /** @type {(inputs: Notifications_Apikey_Clear1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ryd Nøgle`)
};

const de_notifications_apikey_clear1 = /** @type {(inputs: Notifications_Apikey_Clear1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Schlüssel löschen`)
};

const en_us2_notifications_apikey_clear1 = /** @type {(inputs: Notifications_Apikey_Clear1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Clear Key`)
};

const es_es2_notifications_apikey_clear1 = /** @type {(inputs: Notifications_Apikey_Clear1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Borrar clave`)
};

const es_mx2_notifications_apikey_clear1 = /** @type {(inputs: Notifications_Apikey_Clear1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Borrar Key`)
};

const fil_notifications_apikey_clear1 = /** @type {(inputs: Notifications_Apikey_Clear1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`I-clear ang Key`)
};

const fr_notifications_apikey_clear1 = /** @type {(inputs: Notifications_Apikey_Clear1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Effacer la clé`)
};

const it_notifications_apikey_clear1 = /** @type {(inputs: Notifications_Apikey_Clear1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Cancella chiave`)
};

const hu_notifications_apikey_clear1 = /** @type {(inputs: Notifications_Apikey_Clear1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Kulcs törlése`)
};

const nl_notifications_apikey_clear1 = /** @type {(inputs: Notifications_Apikey_Clear1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Sleutel wissen`)
};

const no_notifications_apikey_clear1 = /** @type {(inputs: Notifications_Apikey_Clear1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Fjern nøkkel`)
};

const pl_notifications_apikey_clear1 = /** @type {(inputs: Notifications_Apikey_Clear1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Wyczyść klucz`)
};

const pt_br2_notifications_apikey_clear1 = /** @type {(inputs: Notifications_Apikey_Clear1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Clear Key`)
};

const pt_notifications_apikey_clear1 = /** @type {(inputs: Notifications_Apikey_Clear1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Limpar chave`)
};

const ro_notifications_apikey_clear1 = /** @type {(inputs: Notifications_Apikey_Clear1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Șterge cheia`)
};

const fi_notifications_apikey_clear1 = /** @type {(inputs: Notifications_Apikey_Clear1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Tyhjennä avain`)
};

const sv_notifications_apikey_clear1 = /** @type {(inputs: Notifications_Apikey_Clear1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Rensa nyckel`)
};

const vi_notifications_apikey_clear1 = /** @type {(inputs: Notifications_Apikey_Clear1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Xóa khóa`)
};

const tr_notifications_apikey_clear1 = /** @type {(inputs: Notifications_Apikey_Clear1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Anahtarı Temizle`)
};

const cs_notifications_apikey_clear1 = /** @type {(inputs: Notifications_Apikey_Clear1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Vymazat klíč`)
};

const bg_notifications_apikey_clear1 = /** @type {(inputs: Notifications_Apikey_Clear1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Изчистване на ключ`)
};

const ru_notifications_apikey_clear1 = /** @type {(inputs: Notifications_Apikey_Clear1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Очистить ключ`)
};

const uk_notifications_apikey_clear1 = /** @type {(inputs: Notifications_Apikey_Clear1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Очистити ключ`)
};

const ar_notifications_apikey_clear1 = /** @type {(inputs: Notifications_Apikey_Clear1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`مسح المفتاح`)
};

const hi_notifications_apikey_clear1 = /** @type {(inputs: Notifications_Apikey_Clear1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`कुंजी साफ़ करें`)
};

const th_notifications_apikey_clear1 = /** @type {(inputs: Notifications_Apikey_Clear1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`ล้างคีย์`)
};

const ja_notifications_apikey_clear1 = /** @type {(inputs: Notifications_Apikey_Clear1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`キーをクリア`)
};

const zh_cn2_notifications_apikey_clear1 = /** @type {(inputs: Notifications_Apikey_Clear1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Clear Key`)
};

const zh_hant1_notifications_apikey_clear1 = /** @type {(inputs: Notifications_Apikey_Clear1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Clear Key`)
};

const ko_notifications_apikey_clear1 = /** @type {(inputs: Notifications_Apikey_Clear1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Clear Key`)
};

/**
* | output |
* | --- |
* | "Clear Key" |
*
* @param {Notifications_Apikey_Clear1Inputs} inputs
* @param {{ locale?: "id" | "ms" | "da" | "de" | "en-US" | "es-ES" | "es-MX" | "fil" | "fr" | "it" | "hu" | "nl" | "no" | "pl" | "pt-BR" | "pt" | "ro" | "fi" | "sv" | "vi" | "tr" | "cs" | "bg" | "ru" | "uk" | "ar" | "hi" | "th" | "ja" | "zh-CN" | "zh-Hant" | "ko" }} options
* @returns {LocalizedString}
*/
const notifications_apikey_clear1 = /** @type {((inputs?: Notifications_Apikey_Clear1Inputs, options?: { locale?: "id" | "ms" | "da" | "de" | "en-US" | "es-ES" | "es-MX" | "fil" | "fr" | "it" | "hu" | "nl" | "no" | "pl" | "pt-BR" | "pt" | "ro" | "fi" | "sv" | "vi" | "tr" | "cs" | "bg" | "ru" | "uk" | "ar" | "hi" | "th" | "ja" | "zh-CN" | "zh-Hant" | "ko" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Notifications_Apikey_Clear1Inputs, { locale?: "id" | "ms" | "da" | "de" | "en-US" | "es-ES" | "es-MX" | "fil" | "fr" | "it" | "hu" | "nl" | "no" | "pl" | "pt-BR" | "pt" | "ro" | "fi" | "sv" | "vi" | "tr" | "cs" | "bg" | "ru" | "uk" | "ar" | "hi" | "th" | "ja" | "zh-CN" | "zh-Hant" | "ko" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "id") return id_notifications_apikey_clear1(inputs)
	if (locale === "ms") return ms_notifications_apikey_clear1(inputs)
	if (locale === "da") return da_notifications_apikey_clear1(inputs)
	if (locale === "de") return de_notifications_apikey_clear1(inputs)
	if (locale === "en-US") return en_us2_notifications_apikey_clear1(inputs)
	if (locale === "es-ES") return es_es2_notifications_apikey_clear1(inputs)
	if (locale === "es-MX") return es_mx2_notifications_apikey_clear1(inputs)
	if (locale === "fil") return fil_notifications_apikey_clear1(inputs)
	if (locale === "fr") return fr_notifications_apikey_clear1(inputs)
	if (locale === "it") return it_notifications_apikey_clear1(inputs)
	if (locale === "hu") return hu_notifications_apikey_clear1(inputs)
	if (locale === "nl") return nl_notifications_apikey_clear1(inputs)
	if (locale === "no") return no_notifications_apikey_clear1(inputs)
	if (locale === "pl") return pl_notifications_apikey_clear1(inputs)
	if (locale === "pt-BR") return pt_br2_notifications_apikey_clear1(inputs)
	if (locale === "pt") return pt_notifications_apikey_clear1(inputs)
	if (locale === "ro") return ro_notifications_apikey_clear1(inputs)
	if (locale === "fi") return fi_notifications_apikey_clear1(inputs)
	if (locale === "sv") return sv_notifications_apikey_clear1(inputs)
	if (locale === "vi") return vi_notifications_apikey_clear1(inputs)
	if (locale === "tr") return tr_notifications_apikey_clear1(inputs)
	if (locale === "cs") return cs_notifications_apikey_clear1(inputs)
	if (locale === "bg") return bg_notifications_apikey_clear1(inputs)
	if (locale === "ru") return ru_notifications_apikey_clear1(inputs)
	if (locale === "uk") return uk_notifications_apikey_clear1(inputs)
	if (locale === "ar") return ar_notifications_apikey_clear1(inputs)
	if (locale === "hi") return hi_notifications_apikey_clear1(inputs)
	if (locale === "th") return th_notifications_apikey_clear1(inputs)
	if (locale === "ja") return ja_notifications_apikey_clear1(inputs)
	if (locale === "zh-CN") return zh_cn2_notifications_apikey_clear1(inputs)
	if (locale === "zh-Hant") return zh_hant1_notifications_apikey_clear1(inputs)
	return ko_notifications_apikey_clear1(inputs)
});
export { notifications_apikey_clear1 as "notifications.apiKey.clear" }